import {APIClient} from "@crunchyroll/cx-api-client-lite";

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} AuthAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} createToken
 */
/**
 * @type {AuthAPIClient | APIClient}
 */
const Auth = new APIClient({
  createToken: {
    path: "/auth/v1/token",
    method: "POST",
    options: {
      withCredentials: true,
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
    },
  },
});

export default Auth;
